import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";

import App from "@/app/App";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TanStackDevtools } from "@tanstack/react-devtools";
import { formDevtoolsPlugin } from "@tanstack/react-form-devtools";
import { HotkeysProvider } from "@tanstack/react-hotkeys";
import { hotkeysDevtoolsPlugin } from "@tanstack/react-hotkeys-devtools";
import { pacerDevtoolsPlugin } from "@tanstack/react-pacer-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
import { setDefaultOptions } from "date-fns";
import { enGB } from "date-fns/locale";

import store from "../store";

const queryClient = new QueryClient();

function Root() {
  polyfillCountryFlagEmojis();

  setDefaultOptions({ weekStartsOn: 1, locale: enGB });

  return (
    <Provider store={store}>
      <HotkeysProvider
        defaultOptions={{
          hotkey: { requireReset: true },
        }}
      >
        <QueryClientProvider client={queryClient}>
          <TanStackDevtools
            config={{ hideUntilHover: true }}
            plugins={[
              { name: "TanStack Query", render: <ReactQueryDevtoolsPanel /> },
              formDevtoolsPlugin(),
              pacerDevtoolsPlugin(),
              hotkeysDevtoolsPlugin(),
            ]}
          />
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </LocalizationProvider>
        </QueryClientProvider>
      </HotkeysProvider>
    </Provider>
  );
}

export default Root;
